import { ChartOptionsCollapsible } from 'Benchmarks/ChartOptionsCollapsible';
import {
	Wrapper,
	OptionsWrapper,
} from '../../ChartOptions/ChartOptions.styles';
import React, { useContext } from 'react';
import IndustryMultiSelect from 'Benchmarks/ChartOptions/IndustryMultiSelect';
import { ApButtonMain, ApSimpleDropdown } from '@alixpartners/ui-components';
import MonthPicker from 'Settings/FirstUsageSettings/MonthPicker';
import { procurementMetricsContext } from '../Context/ProcurementMetricsContextProvider';
import {
	BREAKDOWN_FILTER_OPTIONS,
	INDUSTRY_OPTIONS,
	REGION_OPTIONS,
} from 'Benchmarks/utils';

const ProcurementFilters = () => {
	const {
		industries,
		onChangeIndustry,
		regions,
		onChangeRegion,
		dateRangeData,
		onChangeDateRange,
		setApplyFilter,
		applyFilter,
		activeTabId,
		setProcurementMetricsNumericalData,
		setTab2Data,
		handleFilterByChangeCategory,
		currentBreakDownFilterCategory,
		currentFilterOptionsCategory,
		currentFilterValuesSelectedCategory,
		setcurrentFilterValuesSelectedCategory,
		setHierarchyData,
		defaultDateRange,
		setDateRangeData,
		isFilterDisabled,
	} = useContext(procurementMetricsContext);

	return (
		<ChartOptionsCollapsible>
			<Wrapper>
				<OptionsWrapper>
					{activeTabId === 2 && (
						<>
							<ApSimpleDropdown
								label={`Filter By`}
								onChange={e => handleFilterByChangeCategory(e)}
								options={BREAKDOWN_FILTER_OPTIONS.filter(
									item => item.value !== 'Vendor_Name'
								)}
								selected={BREAKDOWN_FILTER_OPTIONS.find(
									e => e.value === currentBreakDownFilterCategory.value
								)}
								disabled={true}
							/>
							<IndustryMultiSelect
								name={`${currentBreakDownFilterCategory.label}`}
								label={`${currentBreakDownFilterCategory.label}`}
								options={currentFilterOptionsCategory}
								selected={currentFilterValuesSelectedCategory}
								onChange={v => {
									setcurrentFilterValuesSelectedCategory(v);
								}}
								disabled={true}
							/>
						</>
					)}
					<IndustryMultiSelect
						name="industry"
						label="Industries"
						options={INDUSTRY_OPTIONS}
						selected={industries}
						disabled={isFilterDisabled}
						onChange={e => onChangeIndustry(e)}
					/>
					<IndustryMultiSelect
						name="region"
						label="Region"
						options={REGION_OPTIONS}
						selected={regions}
						disabled={isFilterDisabled}
						onChange={e => onChangeRegion(e)}
					/>
					{dateRangeData.srcRange &&
						dateRangeData.stateRange && (
							<div style={{ pointerEvents: isFilterDisabled ? 'none' : 'all' }}>
								<MonthPicker
									srcRange={dateRangeData.srcRange}
									stateRange={dateRangeData.stateRange}
									onConfirm={e => onChangeDateRange(e)}
									// onConfirm={() => {}}
								/>
							</div>
						)}
					<ApButtonMain
						title="Apply Filter"
						iconName="filter_outlined"
						onClick={() => {
							setProcurementMetricsNumericalData([]);
							setTab2Data([]);
							setHierarchyData([]);
							setApplyFilter(!applyFilter);
						}}
						disabled={isFilterDisabled}
					>
						Apply
					</ApButtonMain>

					<ApButtonMain
						style={{ marginLeft: '10px' }}
						title="Reset"
						iconName="filter_outlined"
						onClick={() => {
							setProcurementMetricsNumericalData([]);
							setTab2Data([]);
							setHierarchyData([]);
							onChangeIndustry([]);
							onChangeRegion([]);
							setcurrentFilterValuesSelectedCategory([]);
							setDateRangeData(defaultDateRange);
							setApplyFilter(!applyFilter);
						}}
						disabled={isFilterDisabled}
					>
						Reset
					</ApButtonMain>
				</OptionsWrapper>
			</Wrapper>
		</ChartOptionsCollapsible>
	);
};

export default ProcurementFilters;
